<template>
  <div style="width: 100%;">
    <el-carousel indicator-position="outside"
                 style="width:100%"
                 arrow="never"
                 height="380px">
      <el-carousel-item v-for="(x,y) in list"
                        :key="y+'x'">
        <div style="margin-top:20px;width: 100%;">
          <!-- :style="{'backgroundImage':'url(' + item.url + ')' ,'backgroundPosition':'50%','backgroundSize':index != activeIndex?'cover':'100% 100%' ,'backgroundRepeat': 'no-repeat'}" -->
          <div class="witness_list">
            <!-- 左侧大屏 -->
            <div @mouseenter="mouseover(-1)"
                 @mouseleave="mouseout"
                 @click="itemClick(item)"
                 v-if="index==0"
                 v-for="(item,index) in x"
                 :key="index"
                 class="left">
              <!-- <el-image class="dong"
                        :style="{'transform':activeIndex==-1?'scale(1.5)':''}"
                        :src="item.resourceUrl"
                        alt=""></el-image> -->
              <img class="dong"
                   :style="{'transform':activeIndex==-1?'scale(1.5)':''}"
                   :src="item.resourceType == '1'? item.resourceUrl:item.coverUrl"
                   alt="">
              <div class="active">{{item.titleName}}</div>
            </div>
            <div class="right">
              <div class="witness_item"
                   v-if="index>=1"
                   v-for="(item,index) in x"
                   :key="index"
                   @mouseenter="mouseover(index)"
                   @mouseleave="mouseout"
                   @click="itemClick(item)">
                <!-- <el-image class="dong"
                          :style="{'transform':activeIndex==index?'scale(1.5)':''}"
                          :src="item.resourceUrl"
                          alt=""></el-image> -->
                <img class="dong"
                     :style="{'transform':activeIndex==index?'scale(1.5)':''}"
                     :src="item.resourceType == '1'? item.resourceUrl:item.coverUrl"
                     alt="">
                <div class="active">{{item.titleName}}</div>
              </div>
            </div>
            <!-- <div v-else
                 style="flex:1;"
                 class="right">
              <div class="witness_item_content">
                <img class="dong"
                     :style="{'transform':activeIndex==index?'scale(1.5)':''}"
                     :src="item.url"
                     alt="">
                <div v-if="activeIndex!=index"
                     class="active"></div>
              </div>
            </div> -->
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <videoModal v-if="videoShow"
                ref="videoModal"
                @close="closeModal"></videoModal>
    <!-- <el-dialog custom-class="dialogClass"
               :visible.sync="centerDialogVisible"
               width="50%"
               center>
      <div>
        <video controls
               class="video"
               :autoplay="false"
               :src="videoUrl"></video>
      </div>

    </el-dialog> -->
  </div>
</template>
<script>
import videoModal from '@/components/video/videoModal.vue'
export default {
  props: {
    list: {
      type: Array,
      default: {
        return: []
      }
    }
  },
  components: { videoModal },
  data () {
    return {
      videoShow: false,
      videoUrl: 'https://api.dogecloud.com/player/get.mp4?vcode=5ac682e6f8231991&userId=17&ext=.mp4',
      centerDialogVisible: false,
      activeIndex: -2
    }
  },
  methods: {
    itemClick (item) {
      if (item.resourceType == '2') {
        this.videoShow = true;
        this.$nextTick(() => {
          this.$refs.videoModal.init(item)
        })
      }
    },
    closeModal () {
      this.videoShow = false;
    },
    mouseover (e) {
      console.log(e)
      this.activeIndex = e
    },
    mouseout () {
      this.activeIndex = -2
    }
  }
}
</script>
<style lang="less" scoped>
.dialogClass {
  padding: 0 !important;
}
.video {
  width: 100%;
  height: 100%;
}
.witness_list {
  width: 100%;
  display: flex;
  height: 364px;
  .left {
    flex: 1;
    height: 100%;
    overflow: hidden;
    transition: all 0.3s ease-in-out;
    position: relative;
  }
  .dong {
    width: 100%;
    height: 100%;
    transition: all 2s;
    z-index: 11;
  }
  .dong:hover {
    transform: scale(1.2);
    cursor: pointer;
  }
  .active {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 56px;
    line-height: 56px;
    text-align: center;
    background: rgba(0, 0, 0, 0.6);
    color: #ffffff;
    font-size: 16px;
    z-index: 1;
  }
  // witness_item
  .right {
    flex: 1;
    width: 100%;
    .witness_item {
      display: inline-block;
      width: 50%;
      height: 182px;
      // padding: 20px;
      box-sizing: border-box;
      background-color: #fff;
      transition: all 0.3s ease-in-out;
      position: relative;
      overflow: hidden;
      // .hide {
      //   width: 100%;
      //   height: 100%;
      //   padding: 50px;
      //   border-radius: 10px;
      //   box-sizing: border-box;
      //   background: rgba(0, 0, 0, 0.4);
      //   color: #fff;
      //   display: flex;
      //   align-items: center;
      //   text-align: center;
      //   justify-content: center;
      //   font-size: 30px;
      // }
      // .show {
      //   position: absolute;
      //   bottom: 0;
      //   left: 0;
      //   width: 100%;
      //   height: 100%;
      //   background: rgba(255, 0, 0, 0.6);
      //   border-radius: 10px;
      //   padding: 30px;
      //   box-sizing: border-box;
      //   color: #fff;
      // }
    }
  }
}
</style>